import { createContext } from 'react';
/**
 * Provides the raw feed object. Useful for sharing external feeds to hydrate
 * the widget.
 */
export const HydratedFeedContext = createContext(undefined);
/** Provides the feed query result. */
export const FeedQueryContext = createContext(undefined);
